// MeetingTitle.js
import { Box } from "@mui/material";
import { useTemplateFontSettings } from 'styles/templateFontSettings';

const DshBoxTitle = ({ title, color = "primary", secondTitle }) => {
    

    const titleBarSx = {
        textAlign: "center",
        fontWeight: 450,
        py: 1,
        borderRadius: 1,
        mb: 2,
        userSelect: 'none',
        WebkitUserSelect: 'none',
    };

    const content = (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            gap: 1,
            px: 1,
            userSelect: 'none',
        }}>
            <span style={{ flex: 1, textAlign: 'center' }}>{title}</span>
            {secondTitle !== undefined && (
                <span style={{ fontStyle: 'italic', whiteSpace: 'nowrap', flexShrink: 0 }}>
                    {secondTitle}
                </span>
            )}
        </Box>
    );

    return (
        color === "primary" ?
            <Box gutterBottom sx={{ ...titleBarSx, color: "primary.main", backgroundColor: '#eef2ff' }}>
                {content}
            </Box>
            : color === "blue" ?
                <Box gutterBottom sx={{ ...titleBarSx, color: "#2EB5C9", backgroundColor: "rgba(46,181,201,0.1)" }}>
                    {content}
                </Box>
                : color === "subheader" ?
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Box gutterBottom sx={{ ...titleBarSx, color: "primary.main", fontWeight: 400, py: 0.7, borderRadius: 10, width: "25%", backgroundColor: '#eef2ff' }}>
                            {content}
                        </Box>
                    </div>
                    : color === "warning" ?
                        <Box gutterBottom sx={{ ...titleBarSx, color: "warning.main", backgroundColor: '#eef2ff' }}>
                            {content}
                        </Box>
                        : color === "error" ?
                            <Box gutterBottom sx={{ ...titleBarSx, color: "#E73145", backgroundColor: "#ffe5e9" }}>
                                {content}
                            </Box>
                            :
                            <Box gutterBottom sx={{ ...titleBarSx, color: "primary.main", backgroundColor: '#eef2ff' }}>
                                {content}
                            </Box>
    );
};

export default DshBoxTitle;
